import { render } from "./AdminContainerList.vue?vue&type=template&id=54a4f8bc"
import script from "./AdminContainerList.vue?vue&type=script&lang=js"
export * from "./AdminContainerList.vue?vue&type=script&lang=js"
script.render = render

export default script